import React, { Component, isValidElement, createElement  } from "react";
import ArticleContainer from "./ArticleContainer";
import OneColumnPage from "../layouts/OneColumnPage";
import TwoColumnPage from "../layouts/TwoColumnPage";
import TwoColumnFullWidthHeaderPage from "../layouts/TwoColumnFullWidthHeaderPage";
import SolutionContainer from "./SolutionSection/SolutionContainer";
import VastPROLogoContainer from "./LogoSection/VastPROLogoContainer";
import CallToActionContainer from "./CallToActionSection/CallToActionContainer";
import ClientSucessStoryContainer from "./ClientSucessStorySection/ClientSucessStoryContainer";
import InstructionalVideosContainer from "./InstructionalVideoSection/InstructionalVideosContainer";
import FAQAccordian from "./FAQCustomAccordianContainer/FAQAccordian";
import IframeContainer from "./IframeContainer/IframeContainer";
import CssPage from "../layouts/CssPage";
import CssContent from "./CssContent";
//import HeaderContainer from "./HeaderContainer/HeaderContainer";
import FooterContainerCarolina from "./FooterCarolina/FooterContainerCarolina";
import customSliderContainer from "./CustomSliderRendering/CustomSliderContainer";
import CbHomeTemplate from "../layouts/CbHomeTemplate";
import PdfDocumentContainer from "./PdfDocumentContainer/PdfDocumentContainer";
import { BuildingBlocksLeft } from "./BuildingBlocksLeft/BuildingBlocksLeft";
import PageSlotContainer from "../layouts/PageSlotContainer";
import  ContentRuleFolder  from "./ContentFolder/ContentRuleFolder";
import FooterContainer from "../layouts/FooterContainer";
import CbCarouselVertical from "./CbCarouselVertical/CbCarouselVertical";
import { CbLogin } from "./CbLogin/CbLogin";
import { CbRegister } from "./CbRegister/CbRegister";
import { CbForgotPassword } from "./CbForgotPassword/CbForgotPassword";
import ResultsContainer from "./PlpSection/ResultsContainer";
import BreadCrumbsContainer from "./BreadCrumbs/BreadCrumbsContainer";
import FacetsContainer from "./Facets/FacetsContainer";
import { CbSchoolRegister } from "./CbSchoolRegister/CbSchoolRegister";
import MyAccount from "./ShoppingList/MyAccount";
import MyProfile from "./ShoppingList/MyProfile";
import { CbGuestRegisterForm } from "./CbRegister/CbGuestRegisterForm";
import OrderHistory from "./ShoppingList/OrderHistory";
import OrderDetail from "./ShoppingList/OrderDetail";
import ShoppingListDetail from"./ShoppingListDetail/ShoppingListDetail"
import HtmlRawContainer from "./HtmlRawContainer";
import CheckoutDelivery from "./CheckOutSection/CheckoutDelivery";
import CheckoutBilling from "./CheckOutSection/CheckoutBilling";
import SubmitOrderRequest from "./CheckOutSection/SubmitOrderRequest";
import CheckoutReview from "./CheckOutSection/CheckoutReview";
import {PublicList} from "./ShoppingList/PublicList";
import OrderConfirmation from "./OrderConfirmation/OrderConfirmation";
import {PublicListDetail } from "./ShoppingList/PublicListDetail";
import SelectedCrumbContainer from "./BreadCrumbs/SelectedCrumbContainer";
import {CheckoutHeader} from "./HeaderContainer/CheckoutHeader";
import CbQuickOrder from "./CbQuickOrder/CbQuickOrder";
import MyOrganization from "./ShoppingList/MyOrganization";
import AddressBook from "./CheckOutSection/AddressBook";
import {CSRSearch} from "./HeaderContainer/CSRSearch";
import { Redeem } from "./CheckOutSection/Redeem";
import { RedeemShipping } from "./CheckOutSection/RedeemShipping";
import { RedeemDelivery } from "./CheckOutSection/RedeemDelivery";
import CheckoutConfirm from "./CheckOutSection/CheckoutConfirm";
import AddAddress from "./CheckOutSection/AddAddress";
import ProductDetailsContainer from "./PdpSection/ProductDetailsContainer";
import PdframeContainer from "./Pdframe/PdframeContainer";
import CategoryListingContainer from "./CategoryListingSection/CategoryListingContainer";
import InternalFacetsContainer from "./Facets/InternalFacetsContainer";
import CategoryNameContainer from "./CategoryNameContainer/CategoryNameContainer";
import PluginSlotContainer from "../layouts/PluginSlotContainer";
import { CbImportList } from "./CbImportList/CbImportList";
import { CbPunchoutCategories } from "./CBPunchoutCategories/CbPunchoutCategories";
import FeaturedProductsContainer from "./FeaturedItemSection/FeaturedProductsContainer";
import ZeroResultContainer from "./PlpSection/ZeroResultContainer";
import { CbCsoLogin } from "./CbLogin/CbCsoLogin";
import { CbCsoRegister } from "./CbRegister/CbCsoRegister";
import NewHeaderContainer from "./NewHeaderContainer/NewHeaderContainer";
import FeaturedCategoryContainer from "./FeaturedItemSection/FeaturedCategoryContainer";
import NewFooterContainer from "./NewFooterContainer/NewFooterContainer";
import TargeterContainer from "./TargeterContainer/TargeterContainer";
import SearchedAdjustment from "./PlpSection/SearchedAdjustment";
import MainStaticTitle from "./MainStaticTitle";
import FormPlugin from "./Forms/FormPlugin";
import FormTemplatePlugin from "./Forms/FormTemplatePlugin";
import StaticPageNameContainer from "./StaticPageNameContainer/StaticPageNameContainer";
import { ShopLearn } from "./ShopLearn/ShopLearn";
import HeaderNavTabContainer from "./HeaderNavTabContainer";
import HomepageCategoriesLeftContainer from "./HomepageCategoriesLeftContainer/HomepageCategoriesLeftContainer";
import HubSpotPluginForm from "./HubSpotContainer/HubSpotPluginForm";
import NewMenuContainer from "../layouts/NewMenuContainer";
import NewMenu from "./NewMenu/NewMenu";
import DefaultContainer from "./DefaultContainer";
import RequestCatalog from "./RequestCatalog/RequestCatalog";
import BlogPage from "../layouts/BlogPage";
import BlogHeaderContainer from "../layouts/BlogHeaderContainer";
import BlogFooterContainer from "../layouts/BlogFooterContainer";
import BlogContainer from "./BlogContainer";
import { CbCsoProfile } from "./ShoppingList/CbCsoProfile";
import ShoppingList from "./ShoppingList/ShoppingList";
import DesktopHeaderNavContainer from "./HeaderContainer/DesktopHeaderNavContainer";
import RecentBlogsPlugin from "./RecentBlogsPlugin";
import ShoppingCartV1 from "./ShoppingList/ShoppingCartV1";
import ShoppingCartV2 from "./ShoppingList/ShoppingCartV2";
import CheckoutShipping from "./CheckOutSection/CheckoutShipping";
import SharePlugin from "./SharePlugin";
import OrderResource from "./OrderConfirmation/OrderResource";
import CheckOutDeliveryV1 from "./CheckOutSection/CheckOutDeliveryV1";
import DimensionContainer from "./DimensionTitleContainer/DimensionContainer";
import HostedCatalogFileExport from "./HostedCatalogFileExport/HostedCatalogFileExport";

import '../styles/CbCustomCss.css'
import HeaderContainer from "./HeaderContainer_New/HeaderContainer";
import AdvancedHtmlEditor from "./AdvancedHtmlEditor/AdvancedHtmlEditor";

export class MyComponent extends Component {
  components = {
    OneColumnPage: OneColumnPage,
    CssPage: CssPage,
    TwoColumnPage: TwoColumnPage,
    TwoColumnFullWidthHeaderPage: TwoColumnFullWidthHeaderPage,
    CbHomeTemplate:CbHomeTemplate,
    PageSlotContainer:PageSlotContainer,
    BlogPage:BlogPage,
    BlogHeaderContainer:BlogHeaderContainer,
    BlogFooterContainer:BlogFooterContainer,
    BlogContainer:BlogContainer,
    RecentBlogsPlugin:RecentBlogsPlugin,
    SharePlugin:SharePlugin,
    DefaultPlugin:DefaultContainer,
    PluginSlotContainer:PluginSlotContainer,
    ArticleContainer: ArticleContainer,
    ContentRuleFolder:ContentRuleFolder,
    SliderContainer: customSliderContainer,
    HtmlRawContainer: HtmlRawContainer,
    SolutionContainer: SolutionContainer,
    VastPROLogoContainer: VastPROLogoContainer,
    CallToActionContainer: CallToActionContainer,
    ClientSucessStoryContainer: ClientSucessStoryContainer,
    InstructionalVideosContainer: InstructionalVideosContainer,
    FAQAccordian: FAQAccordian,
    PdframeContainer: PdframeContainer,
    IframeContainer: IframeContainer,
    // HeaderContainer: HeaderContainer,
    HeaderContainer: HeaderContainer,
    FooterContainerCarolina: FooterContainerCarolina,
    CssContent: CssContent,
    CbPunchoutCategories:CbPunchoutCategories,
    BuildingBlocksLeft: BuildingBlocksLeft,
    PdfDocumentContainer: PdfDocumentContainer,
    SelectedCrumbContainer:SelectedCrumbContainer,
    FooterContainer: FooterContainer,
    CbCarouselVertical: CbCarouselVertical,
    CbLogin: CbLogin,
    CbRegister: CbRegister,
    CbForgotPassword: CbForgotPassword,
    ResultsContainer: ResultsContainer,
    CategoryListingContainer: CategoryListingContainer,
    BreadCrumbsContainer: BreadCrumbsContainer,
    ProductDetailsContainer: ProductDetailsContainer,
    FacetsContainer: FacetsContainer,
    ShoppingList:ShoppingList,
    CbSchoolRegister:CbSchoolRegister,
    MyAccount:MyAccount,
    MyProfile:MyProfile,
    CbGuestRegisterForm:CbGuestRegisterForm,
    OrderHistory:OrderHistory,
    OrderDetail:OrderDetail,
    ShoppingListDetail:ShoppingListDetail,
    CheckoutDelivery:CheckoutDelivery,
    CheckoutDeliveryV1:CheckOutDeliveryV1,
    ShoppingCartV1:ShoppingCartV1,
    CheckoutBilling:CheckoutBilling,
    SubmitOrderRequest:SubmitOrderRequest,
    CheckoutReview:CheckoutReview,
    OrderConfirmation:OrderConfirmation,
    CbPublicList:PublicList,
    CbPublicListDetail:PublicListDetail,
    CbCheckoutHeader:CheckoutHeader,
    CheckoutShipping:CheckoutShipping,
    CbQuickOrder:CbQuickOrder,
    MyOrganization:MyOrganization,
    AddressBook:AddressBook,
    CSRSearch:CSRSearch,
    Redeem:Redeem,
    RedeemShipping:RedeemShipping,
    RedeemDelivery:RedeemDelivery,
    CheckoutConfirm:CheckoutConfirm,
    AddAddress:AddAddress,
    InternalFacetsContainer:InternalFacetsContainer,
    CategoryNameContainer:CategoryNameContainer,
    CbImportList:CbImportList,
    FeaturedProductsContainer:FeaturedProductsContainer,
    FeaturedCategoryContainer:FeaturedCategoryContainer,
    ZeroResultContainer:ZeroResultContainer,
    CbCsoLogin:CbCsoLogin,
    CbCsoRegister:CbCsoRegister,
    NewHeaderContainer:NewHeaderContainer,
    NewFooterContainer:NewFooterContainer,
    TargeterContainer:TargeterContainer,
    SearchedAdjustmentContainer:SearchedAdjustment,
	  CategoryFeaturedProductsContainer:FeaturedProductsContainer,
    BoostAndBuryFacetsContainer:FacetsContainer,
    BoostAndBuryResultsContainer:ResultsContainer,
	  MainStaticTitle:MainStaticTitle,
    FormPlugin:FormPlugin,
    FormTemplatePlugin:FormTemplatePlugin,
    StaticPageBreadcrumbContainer:BreadCrumbsContainer,
    StaticPageNameContainer:StaticPageNameContainer,
    ShopLearn:ShopLearn,
    HeaderNavTabContainer:HeaderNavTabContainer,
    HomepageCategoriesLeftContainer:HomepageCategoriesLeftContainer,
    CbHubSpot:HubSpotPluginForm,
    NewMenuContainer:NewMenuContainer,
    NewMenu:NewMenu,
    RequestCatalog:RequestCatalog,
    CbCsoProfile:CbCsoProfile,
    DesktopHeaderNavContainer:DesktopHeaderNavContainer,
    ShoppingCartV2:ShoppingCartV2,
    ShoppingCart:ShoppingCartV1,
    OrderResource:OrderResource,
    DimensionTitleContainer:DimensionContainer,
    HostedCatalogFileExport:HostedCatalogFileExport,
    AdvancedHtmlRawContainer:AdvancedHtmlEditor,
    MonetateResultsContainer:ResultsContainer,
    MonetateFacetsContainer:FacetsContainer
  };

 
  render() {
    var key = this.components[this.props.type || 'Loader'];
    //console.log('key ----- mycomponant ', key)
    const ComponentName = key ? key : this.components['DefaultPlugin'];
    return (
      <>
        <ComponentName state={this.props.state} containerObject={this.props.containerObject} contentId={this.props.contentId} dataZone="MainContent" templateName={this.props.templateName} parentAttributes={this.props.parentAttributes ? this.props.parentAttributes : ""}  />
      </>
    )
  }
}

export default MyComponent;
